import * as angular from 'angular';
import { reloadCurrentRoute } from '../../../../../../src/app/shared/utils/navigate-force-reload';

class Receive {
    [x: string]: any;
 	 static $inject = ['InboundNumbersService','$stateParams','$state','Toast', '$http', 'Router'];
    constructor(InboundNumbersService, $stateParams, $state, Toast, $http, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.state = $state;
        this.toast = Toast;
        this.router = Router;
    }

    $onInit() {
        this.settings = angular.copy(this.settings);
        this.msisdnId = this.msisdnid;
    }

    save() {
        this.settings = {...this.settings, checked: true};
        this.InboundNumbersService.setNumberSettings({id: this.msisdnid},
            {receiveCallConfiguration: this.settings, missedCallStrategy: this.settings.missedCallStrategy}, () => {
            this.hide();
            this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(this.router);
        });
    }

    onMessageUpdate() {
      this.InboundNumbersService.getNumberSettings({id: this.msisdnid}, (settings) => {
        this.settings.agentNotLoggedInStrategy.voicemailMessageFile = settings.receiveCallConfiguration.agentNotLoggedInStrategy.voicemailMessageFile;
        this.settings.agentNotLoggedInStrategy.promptMessageFile = settings.receiveCallConfiguration.agentNotLoggedInStrategy.promptMessageFile;
      });
    }

    onChangeAgentOnline(event) {
      this.settings.agentLoggedInStrategy.inboundHandlingStrategyType = event.state;
    }
}
export default {
    controller: Receive,
    template : require('./phone.details.receive.html'),
    bindings: {
        hide: '&',
        settings: '<',
        msisdnid: '<'
    }
};
